import React from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";

function ParametrosSistema() {

    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);

    useEffect(() => {

        if (!localStorage.getItem('userdata')) {
            setLoggedIn(true);
            return;
        }

        const userdata = JSON.parse(localStorage.getItem('userdata'));

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        axios.get('/get-client?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                }
                setLoggedIn(true);
            })
            .catch(() => {
                setLoggedIn(true);
            });
    }, []);

    if (loggedIn) {
        return (
            <div className="wrapper hold-transition" style={{ fontSize: '13px' }}>
                <Header client={client} />
                <Aside client={client} activelink="settings" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb float-sm-left mb-0">
                                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item active">Parámetros del sistema</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2 align-items-end">
                                <div className="col-md-8">
                                    <div className="dash-wrap">
                                        <h1 className="dash-title">Parámetros del sistema</h1>
                                        <p className="dash-subtitle mb-0">EPS, consecutivos, cuenta y seguridad</p>
                                    </div>
                                </div>
                                <div className="col-md-4 mt-2 mt-md-0 text-md-right">
                                    <Link to="/settings" className="btn btn-outline-secondary btn-sm" style={{ borderRadius: '10px', fontWeight: 600 }}>
                                        <i className="fas fa-arrow-left mr-1"></i> Volver a configuración
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="dash-card mb-4">
                                <div className="dash-card-header">
                                    <h2 className="dash-card-title">
                                        <span className="title-icon" aria-hidden="true"><i className="fas fa-cogs"></i></span>
                                        Opciones
                                    </h2>
                                </div>
                                <div className="dash-card-body">
                                    <div className="quick-grid">
                                        <Link to="/aseguradoras" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-hand-holding-medical"></i></div>
                                            <p className="quick-title">EPS / Aseguradoras</p>
                                            <p className="quick-sub">Entidades y planes</p>
                                        </Link>

                                        <Link to="/medios-publicitarios" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-bullhorn"></i></div>
                                            <p className="quick-title">Medios publicitarios</p>
                                            <p className="quick-sub">Canal de captación</p>
                                        </Link>

                                        <Link to="/consecutivos-rs" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-sort-numeric-up"></i></div>
                                            <p className="quick-title">Consecutivos RS</p>
                                            <p className="quick-sub">Numeración y resoluciones</p>
                                        </Link>

                                        <Link to="/areas-localizacion" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-map-marked-alt"></i></div>
                                            <p className="quick-title">Áreas / localizaciones</p>
                                            <p className="quick-sub">Ubicaciones en la historia</p>
                                        </Link>

                                        <Link to="/cuenta" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-user-circle"></i></div>
                                            <p className="quick-title">Información de la cuenta</p>
                                            <p className="quick-sub">Datos del cliente Smile</p>
                                        </Link>

                                        <Link to="/security" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-shield-alt"></i></div>
                                            <p className="quick-title">Seguridad y permisos</p>
                                            <p className="quick-sub">Roles y accesos</p>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>
        );
    }

    return (
        <Loading />
    );
}
export default ParametrosSistema;
